import React from 'react'
import {
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress,
} from '@material-ui/core'
import { VisibilityOutlined } from '@material-ui/icons'
import InfoIcon from '@material-ui/icons/Info'
import { Radio } from 'components/forms/Radio'
import Input from 'components/forms/Input'
import { FmcsaColumns } from 'constants/application'
import { Icon } from 'styles'
import EmptyState from 'components/ds/EmptyState'
import strings from 'strings'

const NoDataIndication = () => (
    <div className='noDataAvailable'>
        <EmptyState compact kind='empty' />
    </div>
)

const FmcsaSearchContent = ({
                                loading,
                                selectedValue,
                                onRadioChange,
                                inputValue,
                                onChange,
                                onSearch,
                                onViewClick,
                                onSelectButton,
                                fmcsaData,
                                creditUsageEnabled,
                                creditCosts,
                                creditCost,
                            }) => {
    const isSearchDisabled = !Boolean(
        inputValue.DOT.length || inputValue.MC.length || inputValue.carrierName.length
    )

    const creditCostEndIcon = creditUsageEnabled && creditCosts ? (
        <span className="creditCostEndIcon">
            <span className="creditCostValue">{creditCost}</span>
            <Icon folder="icons" fileName="credits.svg" />
        </span>
    ) : undefined

    return (
        <>
            {loading && <CircularProgress className='circularLoader' />}

            <div>
                <InfoIcon className="mr-2 mb-1" color="primary" />
                <span>{strings.DASHBOARD.FMCSA_HINT}</span>
            </div>

            <div className='searchFieldContainer mb-2'>
                <div className='d-flex align-items-end'>
                    <Radio
                        checked={selectedValue}
                        onChange={onRadioChange}
                        value="bn"
                        size="small"
                        id="bname-radio"
                    />
                    <Input
                        id="carrierName"
                        label="Business Name"
                        onChange={onChange}
                        disabled={selectedValue !== 'bn'}
                        value={inputValue.carrierName}
                    />
                </div>

                <div className='d-flex align-items-end'>
                    <Radio
                        checked={selectedValue}
                        onChange={onRadioChange}
                        value="mc"
                        size="small"
                        id="mc-radio"
                    />
                    <Input
                        id="MC"
                        label="MC"
                        onChange={onChange}
                        disabled={selectedValue !== 'mc'}
                        value={inputValue.MC}
                        type="number"
                    />
                </div>

                <div className='d-flex align-items-end'>
                    <Radio
                        checked={selectedValue}
                        onChange={onRadioChange}
                        value="dot"
                        size="small"
                        id="dot-radio"
                    />
                    <Input
                        id="DOT"
                        label="DOT"
                        onChange={onChange}
                        disabled={selectedValue !== 'dot'}
                        value={inputValue.DOT}
                        type="number"
                    />
                </div>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={onSearch}
                    disabled={isSearchDisabled}
                    className="fmcsaSearchButton"
                    endIcon={creditCostEndIcon}
                >
                    {strings.SEARCH}
                </Button>
            </div>

            <div className='tableContainer'>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {FmcsaColumns.map((item, index) => (
                                    <TableCell key={index}>{item}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fmcsaData.map((data, index) => {
                                const item = data?.carrier
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{item.legalName}</TableCell>
                                        <TableCell>{item.dbaName}</TableCell>
                                        <TableCell>
                                            {item.phyStreet}
                                            {item.phyCity && `, ${item.phyCity}`}
                                            {item.phyState && `, ${item.phyState}`}
                                        </TableCell>
                                        <TableCell>{item.ein}</TableCell>
                                        <TableCell>{item.dotNumber}</TableCell>
                                        <TableCell>{item.statusCode}</TableCell>
                                        <TableCell>
                                            <VisibilityOutlined onClick={() => onViewClick(item)} />
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className="useBtn"
                                                onClick={() => onSelectButton(item.dotNumber)}
                                            >
                                                {strings.SELECT}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                {(fmcsaData.length === 0 && !loading) && <NoDataIndication />}
            </div>
        </>
    )
}

export default FmcsaSearchContent